import Grid from '@mui/material/Grid';
import MetabolicCard from '../ShopCardsMarker/MetabolicCard';
import LiverPancreasCard from '../ShopCardsMarker/LiverPancreasCard';
import KidneyCard from '../ShopCardsMarker/KidneyCard';
import VitaminsCard from '../ShopCardsMarker/VitaminsCard';
import ImmunityCard from '../ShopCardsMarker/ImmunityCard';
import HormoneCard from '../ShopCardsMarker/HormoneCard';
import Core4Card from '../ShopCardsMarker/Core4Card';

export default function BaseTests() {
  
    return (
          
   <Grid container>
    <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>  

        <Core4Card />

     {/* Cards
    <Grid container spacing={{xs:1, md:2 }}>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><MetabolicCard /></Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><ImmunityCard /> </Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><LiverPancreasCard /></Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><KidneyCard /> </Grid>
      <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><VitaminsCard /> </Grid>
       <Grid size={{xs: 12, sm: 6, xl:4}} sx={{mt:4, display:'flex', justifyContent:'center'}}><HormoneCard /> </Grid>
    </Grid>
    */}
  
  </Grid>          
</Grid> 

)}